import { OPTIONAL_ITEMS, type OptionalItem } from '@witmetrics/unison-core';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { CheckBoxIcon, UncheckBoxIcon } from '@/icons';
import { classes, getValue } from './utils';

const { COMPARE, IPR, ATTACHMENTS } = OPTIONAL_ITEMS;

export type OptionsToggleProps = {
  showCompare: boolean;
  showIpr: boolean;
  showAttachments: boolean;
  onChange: (update: OptionalItem[]) => void;
};

export default function OptionsToggle({
  showCompare,
  showIpr,
  showAttachments,
  onChange,
}: OptionsToggleProps) {
  return (
    <ToggleBlock<OptionalItem[]>
      exclusive={false}
      className={classes.toggleBlock}
      value={getValue(showCompare, showIpr, showAttachments)}
      onChange={onChange}>
      <ToggleOption key={COMPARE} value={COMPARE} tooltip="Show comparison [c]">
        {showCompare ? <CheckBoxIcon /> : <UncheckBoxIcon />}
        <span className={classes.label}>Compare</span>
      </ToggleOption>
      <ToggleOption key={IPR} value={IPR} tooltip="Show IPR [i]">
        {showIpr ? <CheckBoxIcon /> : <UncheckBoxIcon />}
        <span className={classes.label}>IPR</span>
      </ToggleOption>
      <ToggleOption
        key={ATTACHMENTS}
        value={ATTACHMENTS}
        tooltip="Show Attachments [a]">
        {showAttachments ? <CheckBoxIcon /> : <UncheckBoxIcon />}
        <span className={classes.label}>Attachments</span>
      </ToggleOption>
    </ToggleBlock>
  );
}
